export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "indexWorker_57c4f5a.worker.js");
}
